<div data-private>
  <iframe
    #NexioCardIframe
    [id]="NexioFrameId"
    [width]="NexioFrameWidth"
    [height]="NexioFrameHeight"
    [frameBorder]="NexioFrameBorder"
  ></iframe>
</div>
